import f from "../../../funcs";


let Capture = f.CreateClass("Capture");

Capture.prototype.init = function(params) {
    for (let key in params) {
        this[key] = params[key];
    }
    this.blob.lastModifiedDate = new Date();
};

Capture.prototype.setName = function(name) {
    this.name = name;
};

Capture.prototype.upload = function(callback) {
    require([
        "classes/api/FilesApi",
        "classes/modals/UIModal",
        "classes/lang/init"
    ], function(FilesApi, UIModal, langDictionary) {
        let file = new File([this.blob], this.name, {
            type: "image/png",
            encoding: "utf-8"
        });

        FilesApi.uploadToSysFolder({
            filed: [file],
            sysName: "camera"
        }, function(err, rows) {
            if ( err || !f.isArray(rows) || !f.isObject(rows[0]) ) {
                UIModal.error(langDictionary.getError("err_on_upload_camera_photo", err));
                callback(err);
                return;
            }

            this.row = rows[0];
            this.url = this.row.FILE_URL;
            callback(null);
        }.bind(this));
    }.bind(this));
};

export default Capture;
